import throttle from 'lodash/throttle';
import {addTrackingEventGA4} from './Components/TrackingMethods'

class IpRedirectBannerClass {
    constructor() {
        this.bannerSelector = document.querySelector('[data-ipredirectbanner]');
        this.url = this.bannerSelector.dataset.ipredirectbanner;
        this.headerMeta = document.querySelector('.o-header__meta');
        this.init();
        this.scrollListener();
        this.resizeListener();
    }

    init() {
        // Make the AJAX request if not timeout is set
        if (!this.shouldPreventAjaxRequest()) {
            this.fetchBannerContent();
        }
    }

    fetchBannerContent() {

        const url = new URL(window.location.href);
        const simulateIP = url.searchParams.get('simulateIP');
        let transmissionParams = {}
        if (simulateIP) {
            console.warn(`Simulating IP address "${simulateIP}"`)
            transmissionParams = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    'simulateIP': simulateIP
                })
            }
        }

        // Make an AJAX request to the specified URL
        fetch(this.url, transmissionParams)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.status}`);
                }
                return response.text();
            })
            .then((htmlContent) => {
                // Insert the retrieved HTML content into the div with data-ipredirectbanner
                this.bannerSelector.innerHTML = htmlContent;
                if (htmlContent.trim().length) {
                    this.setCloseEvent();
                    this.adjustHeaderPosition();
                    addTrackingEventGA4({
                        trackingEventGeneric: 'country_selection_view',
                        trackingEventGenericCountrySelectionView: `{"country_code":"${this.bannerSelector.querySelector('[data-ipredirectbanner-targetcountrycode]').dataset['ipredirectbannerTargetcountrycode']}"}`
                    })
                }
            })
            .catch((error) => {
                console.error('Error fetching banner content:', error);
            });
    }

    setCloseEvent() {
        const closeButton = this.bannerSelector.querySelector('[data-ipredirectbanner-close]')
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                const currentTimestamp = Date.now();
                this.bannerSelector.remove();
                this.headerMeta.style.top = '';
                this.adjustHeaderPosition();
                localStorage.setItem('ip-redirect-banner-close-timestamp', currentTimestamp.toString());
            });
        }
    }

    shouldPreventAjaxRequest() {
        const lastCloseTimestamp = localStorage.getItem('ip-redirect-banner-close-timestamp');

        if (lastCloseTimestamp) {
            const displayTimeout = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
            const currentTimestamp = Date.now();
            const timeSinceLastClose = currentTimestamp - parseInt(lastCloseTimestamp, 10);
            return timeSinceLastClose < displayTimeout;
        }

        return false;
    }

    adjustHeaderPosition() {
        const height = window.scrollY === 0 ? (this.bannerSelector.offsetHeight) + 'px' : '';
        document.querySelector('.o-header__meta').style.top = height;
        document.querySelector('[data-navigation-dropdown]').style.top = height;
        document.querySelector('[data-offcanvas-target]').style.top = height;
    }

    scrollListener() {
        window.addEventListener('scroll', throttle(() => {
            // Check the scroll position
            if (window.scrollY > 0) {
                // Remove the style.top property when scrolling down
                this.headerMeta.style.top = '';
                this.bannerSelector.classList.add('is-hidden');
            } else {
                // Add the style.top property when scrolling to the top
                this.headerMeta.style.top = (this.bannerSelector.offsetHeight) + 'px';
                this.bannerSelector.classList.remove('is-hidden');
            }
            this.adjustHeaderPosition();
        }, 500));
    }

    resizeListener() {
        window.addEventListener('resize', throttle(() => {
            // Recalculate and adjust the header position on window resize
            this.adjustHeaderPosition();
        }, 250));
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new IpRedirectBannerClass();
});
